import React, { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

interface IrmModalWrapperProps {
  children?: ReactNode
}

export const IrmModalWrapper: FunctionComponent<IrmModalWrapperProps> = ({
  children,
}) => {
  return <Wrapper>{children}</Wrapper>
}

const Wrapper = styled.div`
  > * {
    &:not(:first-child) {
      margin: 24px 0 0 0;
    }

    &:last-child {
      display: block;
      margin-left: auto;
    }
  }
`
